// Pide un rango de días cerrados del Pulso (GET /api/sala/pulso/rango) o de cada modelo (GET /api/sala/modelos/rango).
// El servidor lo calcula con la historia guardada (nunca va al ClickHouse desde la petición); un rango largo tarda ~2 s
// la primera vez y después sale de memoria. Si se cambia de fechas antes de que llegue, la respuesta vieja se descarta.
import { useEffect, useState } from 'react';
import { salaApi } from './api';
import type { RangoModelosSala, RangoSala } from './tipos';

function usePeticionRango<T>(pedir: (desde: string, hasta: string) => Promise<T>, desde: string | null, hasta: string | null): { rango: T | null; cargando: boolean; fallo: boolean } {
  const [estado, setEstado] = useState<{ clave: string; rango: T | null; fallo: boolean } | null>(null);
  const clave = desde && hasta ? `${desde}|${hasta}` : null;
  useEffect(() => {
    if (!desde || !hasta) return;
    let vivo = true;
    pedir(desde, hasta)
      .then((rango) => vivo && setEstado({ clave: `${desde}|${hasta}`, rango, fallo: false }))
      .catch(() => vivo && setEstado({ clave: `${desde}|${hasta}`, rango: null, fallo: true }));
    return () => {
      vivo = false;
    };
    // `pedir` es una función fija de salaApi.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [desde, hasta]);
  const actual = estado && estado.clave === clave ? estado : null;
  return { rango: actual?.rango ?? null, cargando: !!clave && !actual, fallo: actual?.fallo ?? false };
}

export function useSalaRango(desde: string | null, hasta: string | null): { rango: RangoSala | null; cargando: boolean; fallo: boolean } {
  return usePeticionRango(salaApi.rango, desde, hasta);
}

/** Cada modelo en el periodo (22-10, Pau: «cuando cambio de fecha se quita el filtro»). */
export function useSalaRangoModelos(desde: string | null, hasta: string | null): { rango: RangoModelosSala | null; cargando: boolean; fallo: boolean } {
  return usePeticionRango(salaApi.rangoModelos, desde, hasta);
}
